<template>
  <div id="push-model-div" v-if="ishow">
    <div class="app-modal" id="pushdiscount" style="z-index:999999999;">
      <div class="app-modal-wrap">
        <div
          class="app-modal pushdiscount-dialog"
          id="activity-model-dialog"
          style="z-index:999999999;justify-content:center;display:flex;"
        >
          <div
            class="app-modal-wrap"
            style="align-self:center;display:flex;flex-direction:column;position:relative"
          >
            <div class="content" @click="open" :style='{"background":getCountDownImg()}'>
              <div class="close-icon-new" @click.stop="close" :style='{"background":getCountDownCloseImg()}'></div>
              <div>
                <div class="hour">
                  <span>{{ countdown.hour }}</span>
                </div>
                <div class="minute">
                  <span>{{ countdown.minute }}</span>
                </div>
                <div class="second">
                  <span>{{ countdown.second }}</span>
                </div>
                <div class="milliSecond">
                  <span>{{ countdown.milliSecond }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import cookies from "js-cookie";
export default {
  name: "pushumessage_dialog",
  components: {},
  props: ["data"],
  data() {
    return {
      ishow: false,
      activityEndDate: "",
      url:'',
      //倒计时
      countdown: {
        hour: 0,
        minute: 0,
        second: 0,
        milliSecond: 0,
        isShowCountDown: false
      }
    };
  },
  watch: {
    // $route(to) {},
    data(val) {
      if (val) {
        // console.log('有数据');
        this.ishow = val.isShowCountDown == "true";
        this.activityEndDate = val.activityEndDate;
        this.url=val.url;
        if (this.ishow) {
          //判断是否显示活动倒计时弹窗
          //浏览器记录标示已经弹过

          let exp = new Date(this.activityEndDate);
          cookies.set("isShowCountDownDialog", "true", {
            expires: exp
          });
          // cookies.set("isShowCountDownDialog", "true", new Date(this.activityEndDate).toUTCString());

          this.countdown.isShowCountDown = true;
          var self = this;
          setInterval(function() {
            self.countdownFun();
          }, 1);
        }
      }
    }
  },
  computed: {
    ...mapState("user", ["userinfo"])
  },
  mounted() {},
  updated() {},
  methods: {
    close() {
      this.ishow = false;
    },
    //倒计时
    countdownFun() {
      var currentDate = new Date();
      var strEndTime = this.activityEndDate; //"2021-05-25 14:50";
      var EndTime = new Date(strEndTime);

      var days = EndTime - currentDate;
      var longtime = parseInt(days); //精确到秒

      var hour = Math.floor(longtime / 60 / 60 / 1000);
      var minute = Math.floor((longtime - hour * 60 * 60 * 1000) / 1000 / 60);
      var second = Math.floor(
        (longtime - hour * 60 * 60 * 1000 - minute * 60 * 1000) / 1000
      );
      var milliSecond = Math.floor(
        longtime - hour * 60 * 60 * 1000 - minute * 60 * 1000 - second * 1000
      );

      this.countdown.hour = hour >= 0 ? hour : 0;
      this.countdown.minute = minute >= 0 ? minute : 0;
      this.countdown.second = second >= 0 ? second : 0;
      this.countdown.milliSecond = milliSecond >= 0 ? milliSecond : 0;
    },
        getCountDownImg(){
         var host=  location.host;
         var day=new Date().getDate()+new Date().getMinutes();
         if(host.indexOf('d-')>-1 || host.indexOf('localhost')>-1){

             return 'url(../../assets/image/downCount.png?v='+day+') no-repeat';
         }else if(host.indexOf('preview')>-1){
             return 'url(https://p-s0.5118.com/Assist/images/activity/downCount.png?v='+day+') no-repeat';
         }else{
              return 'url(https://s0.5118img.com/Assist/images/activity/downCount.png?v='+day+') no-repeat';

         }

        }
        ,
        getCountDownCloseImg(){
         var host=  location.host;
          var day=new Date().getDate()+new Date().getMinutes();
         if(host.indexOf('d-')>-1 || host.indexOf('localhost')>-1){
               return 'url(../../assets/image/close.png?v='+day+') no-repeat';
               
         }else if(host.indexOf('preview')>-1){
           
               return 'url(https://p-s0.5118.com/Assist/images/activity/close.png?v='+day+') no-repeat';
         }else{
               return 'url(https://s0.5118img.com/Assist/images/activity/close.png?v='+day+') no-repeat';
         }

        },
        open(){
        //   var url=""
        //       var host=  location.host;
        //   if(host.indexOf('d-')>-1 || host.indexOf('localhost')>-1){

        //       url='//dev.5118.com/act/20220701';
        //  }else if(host.indexOf('preview')>-1){
        //       url='//preview.5118.com/act/20220701';
        //  }else{
        //       url= '//www.5118.com/act/20220701';

        //  }

          window.open(this.url)
        }
  }
};
</script>

<style lang="less" scoped>
#push-model-div {
  .app-modal {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: table;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.3);
    transition: opacity 0.2s ease;
  }
  .app-modal-wrap {
    display: table-cell;
    text-align: center;
    vertical-align: middle;
    .content {
      // background: url(../../assets/image/downCount.png) no-repeat;
      width: 414px;
      height: 374px;
      cursor: pointer;
      .close-icon-new {
        // background: url(../../assets/image/close.png) no-repeat;
        width: 50px;
        height: 50px;
        height: 40px;
        width: 40px;
        position: absolute;
        align-self: flex-end;
        cursor: pointer;
        top: -9px;
        right: -17px;
      }
      [v-cloak] {
        display: none;
      }

      .hour {
        color: #d13948;
        position: absolute;
        font-size: 20px;
        font-weight: bold;
        top: 326px;
        left: 65px;
        width: 45px;
        height: 38px;
        /*background: green;*/
        display: flex;
        justify-content: center;
      }

      .hour span {
        align-self: center;
      }

      .minute {
        color: #d13948;
        position: absolute;
        font-size: 20px;
        font-weight: bold;
        top: 326px;
        left: 141px;
        width: 45px;
        height: 38px;
        /*background: green;*/
        display: flex;
        justify-content: center;
      }

      .minute span {
        align-self: center;
      }

      .second {
        color: #d13948;
        position: absolute;
        font-size: 20px;
        font-weight: bold;
        top: 326px;
        left: 214px;
        width: 45px;
        height: 38px;
        /*background: green;*/
        display: flex;
        justify-content: center;
      }

      .second span {
        align-self: center;
      }

      .milliSecond {
        color: #d13948;
        position: absolute;
        font-size: 20px;
        font-weight: bold;
        top: 326px;
        left: 290px;
        width: 64px;
        height: 38px;
        /*background: green;*/
        display: flex;
        justify-content: center;
      }

      .milliSecond span {
        align-self: center;
      }
    }
  }
}
/deep/#push-model-div .close-icon {
  position: absolute !important;
  align-self: flex-end !important;
  cursor: pointer !important;
}
</style>
